@let accessibleProducts = accessibleProducts$ | async;
@let activeProduct = activeProduct$ | async;
@let moreProducts = moreProducts$ | async;

@if (version() === "vfo1") {
  <button
    #menuTrigger="menuTrigger"
    [class.tw-p-3]="sideNavOpen()"
    [class.tw-justify-between]="sideNavOpen()"
    [class.tw-rounded-2xl]="sideNavOpen()"
    [class.tw-p-1]="!sideNavOpen()"
    [class.tw-py-3]="!sideNavOpen()"
    [class.!tw-pe-0]="!sideNavOpen()"
    [class.tw-rounded-lg]="!sideNavOpen()"
    [class.tw-justify-center]="!sideNavOpen()"
    [class.tw-bg-bg-nav-hover]="menuTrigger.isOpen()"
    class="tw-w-full focus-visible:!tw-ring-fg-nav focus-visible:!tw-ring-2 focus-visible:!tw-ring-inset focus-visible:tw-outline-none focus-visible:tw-bg-bg-nav-hover hover:tw-bg-bg-nav-hover tw-flex tw-items-center"
    type="button"
    [attr.aria-label]="'switchProducts' | i18n"
    [bitMenuTriggerFor]="navSwitcherMenu"
    [bitPopoverAnchorFor]="switchProductsCoachmark.popover()"
    [popoverOpen]="coachmark.isStepActive('switchProducts')"
    [position]="coachmark.getStepPosition('switchProducts')"
    [closeOnBackdropClick]="false"
    [spotlight]="coachmark.isStepActive('switchProducts')"
  >
    <div class="tw-flex tw-items-center tw-gap-3 tw-min-w-0">
      @if (activeProduct) {
        <bit-icon-tile
          [size]="sideNavOpen() ? 'base' : 'sm'"
          [icon]="activeProduct.icon"
          [variant]="tileVariant()"
        ></bit-icon-tile>
        @if (sideNavOpen()) {
          <span class="tw-truncate">{{ activeProduct.name }}</span>
        }
      }
    </div>
    <bit-icon name="bwi-up-down-btn"></bit-icon>
  </button>
  <vault-coachmark #switchProductsCoachmark stepId="switchProducts" />
  <bit-menu #navSwitcherMenu>
    <ng-template #moreProductContent let-more>
      <div class="tw-flex tw-justify-between tw-w-full tw-items-center">
        <div>
          <div class="tw-flex tw-items-center tw-gap-2 tw-text-base">
            <bit-icon [name]="more.icon"></bit-icon>
            <div>{{ more.otherProductOverrides?.name ?? more.name }}</div>
          </div>
          @if (more.otherProductOverrides?.supportingText) {
            <div class="tw-text-xs tw-font-normal">
              {{ more.otherProductOverrides.supportingText }}
            </div>
          }
        </div>
        <bit-icon class="tw-text-xl" name="bwi-angle-right"></bit-icon>
      </div>
    </ng-template>
    <div
      role="none"
      class="tw-flex tw-flex-col tw-gap-1"
      [style.width]="'calc(' + sideNavWidthRem() + 'rem - 32px)'"
    >
      @for (product of accessibleProducts; track product.name) {
        <a
          bitMenuItem
          [routerLink]="product.appRoute"
          [attr.aria-current]="product.isActive ? 'page' : null"
          [attr.icon]="product.icon"
          [class.tw-bg-bg-brand-softer]="product.isActive"
          [class.tw-text-fg-heading]="product.isActive"
          class="tw-transition-colors"
        >
          <bit-icon
            [class.tw-opacity-0]="!product.isActive"
            slot="start"
            [name]="'bwi-check'"
          ></bit-icon>
          <bit-icon slot="start" [name]="product.icon"></bit-icon>
          {{ product.name }}
        </a>
      }
    </div>

    @if (moreProducts && moreProducts.length > 0) {
      <div slot="footer">
        @for (more of moreProducts; track more.name) {
          <div role="none">
            @if (more.marketingRoute.external) {
              <!-- <a> for when the marketing route is external -->
              <a
                [href]="more.marketingRoute.route"
                target="_blank"
                rel="noreferrer"
                bitMenuItem
                class="[&_span]:tw-w-full !tw-no-underline"
              >
                <ng-container
                  [ngTemplateOutlet]="moreProductContent"
                  [ngTemplateOutletContext]="{ $implicit: more }"
                ></ng-container>
              </a>
            } @else {
              <!-- <a> for when the marketing route is internal, it needs to use [routerLink] instead of [href] like the external <a> uses. -->
              <a
                [routerLink]="more.marketingRoute.route"
                rel="noreferrer"
                bitMenuItem
                class="[&_span]:tw-w-full !tw-no-underline"
              >
                <ng-container
                  [ngTemplateOutlet]="moreProductContent"
                  [ngTemplateOutletContext]="{ $implicit: more }"
                ></ng-container>
              </a>
            }
          </div>
        }
      </div>
    }
  </bit-menu>
} @else {
  @if (accessibleProducts && accessibleProducts.length > 1) {
    <bit-nav-divider></bit-nav-divider>
    <!-- [attr.icon] is used to keep the icon attribute on the bit-nav-item after prod mode is enabled. Matches other navigation items and assists in automated testing. -->
    @for (product of accessibleProducts; track product.name) {
      <bit-nav-item
        [icon]="product.icon"
        [text]="product.name"
        [route]="product.appRoute"
        [attr.icon]="product.icon"
        [forceActiveStyles]="product.isActive"
        focusAfterNavTarget="body"
      >
      </bit-nav-item>
    }
  }
}

@if (version() !== "vfo1" && (shouldShowPremiumUpgradeButton$ | async)) {
  <app-upgrade-nav-button></app-upgrade-nav-button>
}

@if (version() !== "vfo1" && moreProducts && moreProducts.length > 0) {
  <section class="tw-mt-2 tw-flex tw-w-full tw-flex-col tw-gap-2 tw-border-0">
    <span class="tw-text-xs !tw-text-fg-nav tw-p-2 tw-pb-0">{{ "moreFromBitwarden" | i18n }}</span>
    @for (more of moreProducts; track more.name) {
      <div class="tw-ps-2 tw-pe-2">
        @if (more.marketingRoute.external) {
          <!-- <a> for when the marketing route is external -->
          <a
            [href]="more.marketingRoute.route"
            target="_blank"
            rel="noreferrer"
            class="tw-flex tw-px-3 tw-py-2 tw-rounded-md tw-font-medium !tw-text-fg-nav !tw-no-underline hover:tw-bg-hover-contrast [&>:not(.bwi)]:hover:tw-underline"
          >
            <bit-icon fixedWidth [name]="more.icon" class="tw-mt-1 tw-mx-1"></bit-icon>
            <div>
              {{ more.otherProductOverrides?.name ?? more.name }}
              @if (more.otherProductOverrides?.supportingText) {
                <div class="tw-text-xs tw-font-normal">
                  {{ more.otherProductOverrides.supportingText }}
                </div>
              }
            </div>
          </a>
        } @else {
          <!-- <a> for when the marketing route is internal, it needs to use [routerLink] instead of [href] like the external <a> uses. -->
          <a
            [routerLink]="more.marketingRoute.route"
            rel="noreferrer"
            class="tw-flex tw-px-3 tw-py-2 tw-rounded-md tw-font-medium !tw-text-fg-nav !tw-no-underline hover:tw-bg-hover-contrast [&>:not(.bwi)]:hover:tw-underline"
          >
            <bit-icon fixedWidth [name]="more.icon" class="tw-mt-1 tw-mx-1"></bit-icon>
            <div>
              {{ more.otherProductOverrides?.name ?? more.name }}
              @if (more.otherProductOverrides?.supportingText) {
                <div class="tw-text-xs tw-font-normal">
                  {{ more.otherProductOverrides.supportingText }}
                </div>
              }
            </div>
          </a>
        }
      </div>
    }
  </section>
}
